import { useMemo } from 'react';

import { useGetApiSchoolSettingsQuery } from 'applications/GSP/shared/api/gsp';

export const useSupportedLocales = () => {
  const localization = useGetApiSchoolSettingsQuery().data?.localization;

  const supportedLocaleIds = useMemo(
    () => (localization?.supportedLocales || []).map(locale => locale.id),
    [localization?.supportedLocales],
  );

  return {
    supportedLocaleIds,
    supportedLocales: localization?.supportedLocales || [],
    defaultLocale: localization?.defaultLocale || null,
  };
};
